let DefaultLabelValues = /*#__PURE__*/function (DefaultLabelValues) {
  DefaultLabelValues["UPLOAD"] = "Upload image";
  DefaultLabelValues["DRAG"] = "Or drag and drop image to upload";
  DefaultLabelValues["DROP"] = "Drop the image here";
  DefaultLabelValues["REMOVE"] = "Remove";
  return DefaultLabelValues;
}({});

export { DefaultLabelValues };
//# sourceMappingURL=labels.js.map
